import axios from 'axios';
import { api } from '../../../config';

export const LOCK_RESOURCE_CLAUSE = 'respond-clause-detail';
export const LOCK_RESOURCE_TYPE_RESPONSE =
  'respond-operational-tolerance-validity-document';

export const lockRespondStatus = async ({
  token,
  resource,
  id,
  isLocked = true,
  finalValue = null,
}) => {
  if (!token || !resource || !id) {
    throw new Error('Lock status requires token, resource, and id');
  }

  await axios.put(
    `${api.API_URL}/${resource}/${id}/locked-status?id=${encodeURIComponent(id)}`,
    // finalValue: Final clause/value (free-text lock); cleared on unlock.
    {
      isLocked: isLocked === true,
      finalValue: isLocked === true ? (finalValue ?? null) : null,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
